import React from 'react'

import Wysiwyg from '~/components/core/Wysiwyg/Wysiwyg'
import ButtonArrow from '~/components/core/buttonArrow'
import Image from '~/components/core/Image'
import transformLink from '~/utils/transformLink'

const ImageTextSet = ({ data }) => {
  let chapo = data.chapo
    ? data.chapo.chapo
      ? data.chapo.chapo
      : data.chapo
    : null

  return (
    <div className="fluid-grid image-text-set">
      <div className="flex">
        <div className="col-12 lg-col-4 lg-col-offset-1">
          <h2 className="title-1-bold">{data.title}</h2>

          {chapo && (
            <p className="text-base md:text-20 font-semi-bold leading-medium-small mt-7">
              {chapo}
            </p>
          )}
        </div>
      </div>

      {data.items.map((item, i) => {
        item = item.fields ? item.fields : item

        const cta = item.cta
          ? item.cta.fields
            ? item.cta.fields
            : item.cta
          : null

        let contentTypeContentful, url

        let proportions = item.proportions ? item.proportions : null
        let classesText = 'md-col-6 lg-col-4'
        let classesImg = 'md-col-6 lg-col-5'
        let width = 600

        if (cta) {
          let ctaContent = transformLink(cta, true, false)
          contentTypeContentful = ctaContent.contentTypeContentful
          url = ctaContent.url
        }

        let isEven = i % 2 === 1

        if (proportions) {
          proportions =
            proportions === 'Image plus grande' ? 'bigImg' : 'bigTxt'

          if (proportions === 'bigImg') {
            classesText = 'md-col-6 lg-col-3'
            classesImg = 'md-col-6 lg-col-6'
            width = 720
          } else {
            classesText = 'md-col-6 lg-col-6'
            classesImg = 'md-col-6 lg-col-3'
            width = 360
          }
        }

        return (
          <div
            key={i}
            className={`flex flex-col ${isEven ? 'md:flex-row-reverse md:justify-end' : 'md:flex-row'} ${i === 0 ? 'mt-4 md:mt-10' : 'mt-6 md:mt-25'}`}
          >
            <div
              className={`w-full ${classesText} pt-5 lg-col-offset-1 ${isEven ? 'md:pl-6 lg:pl-0' : 'md:pr-6 lg:pr-0'}`}
            >
              <h3 className="title-2-bold mb-4 md:mb-6">{item.title}</h3>
              <Wysiwyg
                document={item.content}
                classes={cta ? 'mb-5 md:mb-7' : ''}
              />
              {cta && (
                <ButtonArrow
                  link={url}
                  contentType={contentTypeContentful}
                  text={cta.label}
                  color="purple"
                />
              )}
            </div>
            <div className={`w-full ${classesImg} lg-col-offset-1`}>
              {item.image && (
                <Image
                  classes="w-full mt-8 md:mt-0"
                  width={width}
                  maxWidth={true}
                  sizes={{ 415: [354, 259], 767: [707, 518], 1023: [481, 353] }}
                  image={item.image}
                />
              )}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default ImageTextSet
